import styled, { css } from 'styled-components';

import { WEBCHAT_LAUNCHER_LAYOUT } from 'modules/webchat/presentation/constants';

// Abaixo do overlay do atom Modal (z-index 7000), para o pré-chat cobrir o botão.
const LAUNCHER_Z_INDEX = 6900;

export const Container = styled.button`
  ${({ theme }) => css`
    position: fixed;
    right: ${WEBCHAT_LAUNCHER_LAYOUT.offset};
    bottom: ${WEBCHAT_LAUNCHER_LAYOUT.offset};
    z-index: ${LAUNCHER_Z_INDEX};

    width: ${WEBCHAT_LAUNCHER_LAYOUT.size};
    height: ${WEBCHAT_LAUNCHER_LAYOUT.size};

    display: flex;
    align-items: center;
    justify-content: center;

    border: none;
    border-radius: 50%;
    background-color: ${theme.palette.primary.main};
    box-shadow: ${theme.layout.shadows.card};
    color: ${theme.palette.text.white};
    font-size: ${theme.typography.sizes.title2};
    cursor: pointer;
    transition: 0.2s;

    :hover {
      background-color: ${theme.palette.primary.dark};
      transform: scale(1.05);
    }

    :focus-visible {
      outline: 2px solid ${theme.palette.primary.dark};
      outline-offset: 2px;
    }

    @media (min-width: ${WEBCHAT_LAUNCHER_LAYOUT.tabletBreakpoint}) {
      width: ${WEBCHAT_LAUNCHER_LAYOUT.tabletSize};
      height: ${WEBCHAT_LAUNCHER_LAYOUT.tabletSize};
      font-size: ${theme.typography.sizes.title1};
    }
  `}
`;
